var _excluded = ["name"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { Icon as IconSemantic } from 'semantic-ui-react';
import { extensions } from "../../utils";
import { jsx as _jsx } from "react/jsx-runtime";
var IconExtension = function IconExtension(props) {
  var name = props.name,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var iconName = '';
  switch (name) {
    case 'doc':
    case 'docx':
      iconName = 'file word outline';
      break;
    case 'xls':
    case 'xlsx':
      iconName = 'file excel outline';
      break;
    case 'pdf':
      iconName = 'file pdf outline';
      break;
    case 'png':
    case 'jpg':
    case 'jpeg':
      iconName = 'file image outline';
      break;
    case 'pps':
    case 'ppt':
    case 'pptx':
      iconName = 'file powerpoint outline';
      break;
    default:
      iconName = 'file alternate outline';
      break;
  }
  return /*#__PURE__*/_jsx(IconSemantic, Object.assign({
    name: iconName
  }, rest));
};
IconExtension.handledProps = ["name"];
IconExtension.propTypes = {
  name: PropTypes.oneOf(extensions)
};
export default IconExtension;